(ns practitest.frontend.components2.info-note
  (:require [practitest.frontend.components.icons :as icons]))

(defn mux-info-note
  "Renders an info note banner with an icon and a message.
   Accepts a string or hiccup as `message`.
   `icon` overrides the default info-circle icon with any hiccup element.
   When `on-close` is provided, renders a dismiss button on the right."
  [{:keys [message on-close class icon]}]
  [:p.mux-info-note
   {:class [class (when on-close "mux-info-note--dismissible")]}
   (or icon [icons/mux-info-circle])
   [:span.mux-info-note-message message]
   (when on-close
     [:button.mux-info-note-close {:on-click on-close}
      [icons/mux-close]])])
